module.exports = __webpack_public_path__ + "static/img/ecaray_about_introduction_honor01.38eff88c.png";